function setStorage (section, key, type, data) {
    const value = JSON.stringify(data);
    sessionStorage.setItem((section+key+'_'+type), value);
};